// extracted by mini-css-extract-plugin
module.exports = {"expandRecordVisionSetting":"style_expandRecordVisionSetting__g_zee","title":"style_title__deC6v","tip":"style_tip__vihJ1"};